<template>
  <b-button
    :to="to"
    variant="link"
    size="sm"
    class="p-0 text-decoration-none font-weight-normal d-inline-flex align-items-center"
    v-on="$listeners">
    <slot />
  </b-button>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="scss" scoped>

</style>